import { render, staticRenderFns } from "./marketdata.vue?vue&type=template&id=5b79e13c&scoped=true"
import script from "./marketdata.vue?vue&type=script&lang=js"
export * from "./marketdata.vue?vue&type=script&lang=js"
import style0 from "./marketdata.vue?vue&type=style&index=0&id=5b79e13c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79e13c",
  null
  
)

export default component.exports